import NavBar from "@/components/navigation/NavBar"
import Footer from "@/components/navigation/Footer"
import { Mail } from "lucide-react"
import React from "react"
import ContactOptionsTabs from "@/components/calltoaction/CtaContact"

export default function UeberUns() {
  return (
    <div className="font-serif">
      <NavBar className="bg-opacity-100 font-sans border-none shadow-none" />

      {/* Hero Section */}
      <div className="bg-white pt-24 md:pt-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Über Helga Jakobs Immobilien</h1>
           
            {/* <p className="text-xl text-text-100 max-w-3xl mx-auto">
              Ihr vertrauensvoller Partner für Immobilien in Eschweiler und Umgebung. Mit jahrelanger Erfahrung und
              persönlichem Service stehen wir Ihnen bei allen Immobilienangelegenheiten zur Seite.
            </p> */}
          </div>
        </div>
      </div>

      {/* Company Values */}
      

      {/* About Company */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:flex items-center gap-12">
            <div className="lg:w-1/2 mb-10 lg:mb-0">
              <div className="relative h-[400px] overflow-hidden ">
                <img
                  src="/Fotos/ueber-helga-walter.jpg"
                  alt="Helga Jakobs und Walter Jakobs in schwarz weiß"
                  fill
                  className="object-cover"
                />
              </div>
            </div>
            <div className="lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-0">Vertrauen über Generationen | Unsere Geschichte</h2>
              <p className="text-text-100 mb-4">
                
              </p>
              <p className="text-text-100 mb-4">
              Es beginnt mit einer Begegnung – und einer Herzensentscheidung. 1978 gründet Helga Jakobs ihr eigenes Maklerbüro in Eschweiler. Inspiriert wurde sie von ihrer Freundin Caroline Reinartz, damals Maklerin in Aachen – und von der eigenen Suche nach einem Anlageobjekt für die Familie. „Dabei wurde die Leidenschaft für den Maklerberuf in mir geweckt“, erinnert sich Helga.<br/>

Mit Neugier und Engagement eignete sie sich das nötige Wissen an und legte mit der IVD-Prüfung den Grundstein für Helga Jakobs Immobilien – gegründet mit Überzeugung, Herz und Weitblick.
<br className="pt-5 "/>Heute führt Enkel Leon Jakobs das Unternehmen in dritter Generation. Tochter Stefanie begleitet den Weg seit vielen Jahren. Was mit Helgas Mut begann, lebt weiter – mit dem gleichen Anspruch an Qualität, Herzlichkeit und Verlässlichkeit.

Helga, heute über 90 Jahre alt, genießt ihren Ruhestand – ihre Werte aber sind geblieben.
„Uns verbindet nicht nur Expertise, sondern die Liebe zur Region.“ – Helga Jakobs              </p>
              <p className="text-text-100">
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">Unser Team</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Team Member 1 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="relative h-80 overflow-hidden">
                <img src="/Fotos/ueber-leon.jpg" alt="Leon Jakobs" fill className="object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">Leon Jakobs</h3>
                <p className="text-prime-600 font-medium mb-4">Geschäftsführer & Immobilienmakler</p>
                <p className="text-text-100 mb-4">
                “Mein Ziel ist es das Klassische mit dem Modernen zu verbinden.”
                </p>
                <div className="flex items-center text-text-100">
                  <Mail className="w-5 h-5 mr-2 text-prime-600" />
                  <span>l.jakobs@jakobs-immobilien.de</span>
                </div>
              </div>
            </div>

            {/* Team Member 2 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="relative h-80 overflow-hidden">
                <img src="/Fotos/ueber-stefanie.jpg" alt="Stefanie Jakobs" fill className="object-cover " />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">Stefanie Jakobs</h3>
                <p className="text-prime-600 font-medium mb-4">Immobilienverwaltung</p>
                <p className="text-text-100 mb-4">
                “Die Kombination aus persönlichem Kontakt und organisatorischen Herausforderungen motiviert mich Tag für Tag.”
                </p>
                <div className="flex items-center h-full text-text-100">
                  <Mail className="w-5 h-5 mr-2 text-prime-600" />
                  <span>s.jakobs@jakobs-immobilien.de</span>
                </div>
              </div>
            </div>

            {/* Team Member 3 */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="relative h-80 overflow-hidden">
                <img src="/Fotos/ueber-helga.jpg" alt="Helga Jakobs" fill className="object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">Helga Jakobs</h3>
                <p className="text-prime-600 font-medium mb-4">Gründerin im Ruhestand</p>
                <p className="text-text-100 mb-4">
                “Zufriedene Kunden sind die beste Werbung. Daher war es von Anfang an mein Anspruch, jede Immobilie so zu behandeln, als wäre sie meine eigene.”
                </p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div>
            <h2 className="md:text-3xl text-2xl font-semibold text-gray-900 md:mb-10 mb-6 text-center">
              Unsere Partner
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-prime-50 p-8 rounded-lg text-center">
              <div className="w-40  rounded-full flex items-center justify-center mx-auto mb-6">
              <img src="/Logos/ina24.jpg" alt="Ina24 Logo" />

              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">INA24</h3>
              <p className="text-text-100">
              Das Netzwerk INA24 verbindet erfahrene Immobilienmakler in der Region Aachen, Düren und Heinsberg für eine besonders effektive Vermarktung von Immobilien.
              </p>
            </div>

            <div className="bg-prime-50 p-8 rounded-lg text-center">
              <div className=" w-24  rounded-full flex items-center justify-center mx-auto mb-4">
                <img src="/Logos/IVD-Logo.png" alt="IVD Logo" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">IVD</h3>
              <p className="text-text-100">Der IVD ist der führende Berufsverband der Immobilienwirtschaft in Deutschland und steht für Fachkompetenz, Qualität und Markttransparenz.</p>
            </div>

            <div className="bg-prime-50 p-8 rounded-lg text-center">
              <div className="w-40  rounded-full flex items-center justify-center mx-auto mb-4">
              <img src="/Logos/Partner-Siegel-Immoscout24.png" alt="Immobilienscout24 Partnersiegel" />

              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">ImmosScout24</h3>
              <p className="text-text-100">ImmoScout24 ist Deutschlands größte Online-Plattform für Immobilien, auf der Millionen Menschen nach Kauf- und Mietobjekten suchen.</p>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Section */}
      <div className="py-10">
        <ContactOptionsTabs />
      </div>

      <Footer />
    </div>
  )
}
